import $ from 'jquery';

const TrackME = {
  run: function(sessionId, domain) {
    if (window.$infoReader) {
      window.$infoReader.run(
        sessionId,
        null,
        global.env.ANTI_FRAUD_APP_DOMAIN + '_INTERLINE_' + domain
      );
    } else {
      try {
        $.getScript('https://trkme.bigdatacorp.com.br/lib/trcklibiframe.min.js').then(function() {
          window.$infoReader.run(
            sessionId,
            null,
            global.env.ANTI_FRAUD_APP_DOMAIN + '_INTERLINE_' + domain
          );
        });
      } catch (err) {
        console.log('Error TrackMe script: ' + err);
      }
    }
  }
};
export default TrackME;



// WEBPACK FOOTER //
// ./src/components/modules/trackMe/index.js